import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TransportInvoiceModel } from 'src/app/models/additional/transport-invoice.model';
import { TransportInvoiceService } from 'src/app/services/additional/transport-invoice.service';
import { ProviderService } from 'src/app/services/archive/provider.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-transport-invoice',
  templateUrl: './register-transport-invoice.component.html',
  styleUrls: ['./register-transport-invoice.component.scss'],
  standalone: false
})
export class RegisterTransportInvoiceComponent implements OnInit {

  companyId: number = 0;
  disabledForm: boolean = false;
  formTransportInvoice: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listProviders: any[] = [];
  nameWindow: string = 'Captura Facturas de Transporte';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = 'success';
  stateTransportInvoice: string = '';
  titleState: string = '';
  transportInvoiceContract: TransportInvoiceModel = new TransportInvoiceModel();
  transportInvoiceId: number = 0;
  url: string = 'transport-invoice';

  constructor(
    private activatedRoute: ActivatedRoute,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private dateConverterService: DateConverterService,
    private headerService: HeaderService,
    private location: Location,
    private formControlStateService: FormControlStateService,
    private providerService: ProviderService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private transportInvoiceService: TransportInvoiceService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService
  ) {
    this.validateForm(new TransportInvoiceModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.transportInvoiceId = Object.keys(params).length > 0 ? Number(params?.id) : 0;
    });
    await this.getPermission();
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeStateTransportInvoice() {
    if (!this.transportInvoiceId || this.transportInvoiceId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe guardar primero la factura de transporte.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para cambiar el estado de la factura de transporte. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response: TransportInvoiceModel = await firstValueFrom(
        this.transportInvoiceService.setActiveTransportInvoice(this.transportInvoiceContract.transportInvoiceId)
      );
      this.transportInvoiceContract = response;
      this.validateForm(this.transportInvoiceContract);
      if (response.active) {
        this.toastHandlerService.showToast(
          'success',
          'La factura de transporte fue activada exitosamente.'
        );
      } else {
        this.toastHandlerService.showToast(
          'success',
          'La factura de transporte fue inactivada exitosamente.'
        );
      }
    } catch (error) {
      console.error('Error al cambiar el estado de la factura de transporte.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear facturas de transporte. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.quantityDetails = 0;
    this.transportInvoiceId = 0;
    this.transportInvoiceContract = new TransportInvoiceModel();
    this.transportInvoiceContract.companyId = this.companyId;
    this.validateForm(this.transportInvoiceContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  getQuantityDetails(quantity: number) {
    this.quantityDetails = quantity;
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar la factura de transporte. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (!this.transportInvoiceId || this.transportInvoiceId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe guardar una factura de transporte.'
      );
      return;
    }

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La factura de transporte no puede ser eliminada ya que tiene detalles asociados.'
      );
      return;
    }


    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar la factura de transporte?')) {
      try {
        await firstValueFrom(this.transportInvoiceService.deleteTransportInvoice(this.transportInvoiceContract.transportInvoiceId));
        this.createNewRegister();
        this.toastHandlerService.showToast(
          'success',
          'La factura de transporte fue eliminada exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar la factura de transporte.', error);
      }
    }
  }

  async getAllLists() {
    try {
      const providers: any = await firstValueFrom(this.providerService.getAllProvidersTransportForSelect());
      this.listProviders = providers || [];
    } catch (error) {
      console.error('Error al obtener los proveedores.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    const providerId = this.formTransportInvoice.get("providerId")?.value
    const documentNumber = this.formTransportInvoice.get("documentNumber")?.value;

    if (providerId == null || providerId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un proveedor.', 'Atención');
      return;
    }

    const transportInvoiceId = documentNumber === 0 ? 0 : this.transportInvoiceContract.transportInvoiceId;
    this.handleInvoiceNavigation(buttonClick, providerId, transportInvoiceId);
  }

  async handleInvoiceNavigation(buttonClick: any, providerId: number, transportInvoiceId: number) {
    const actionMap: Record<string, () => Promise<TransportInvoiceModel>> = {
      first: () => firstValueFrom(this.transportInvoiceService.getFirstTransportInvoiceByKeysAsync(providerId)),
      previus: () => firstValueFrom(this.transportInvoiceService.getPreviusTransportInvoiceByKeysAsync(providerId, transportInvoiceId)),
      next: () => firstValueFrom(this.transportInvoiceService.getNextTransportInvoiceByKeysAsync(providerId, transportInvoiceId)),
      last: () => firstValueFrom(this.transportInvoiceService.getLastTransportInvoiceByKeysAsync(providerId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      return;
    }
    try {
      const transportInvoice = await action();
      this.transportInvoiceId = transportInvoice.transportInvoiceId;
      this.transportInvoiceContract = transportInvoice;
      await this.validateForm(this.transportInvoiceContract);
      this.location.replaceState(`/transport-invoice/register/${this.transportInvoiceId}`);
    } catch (error) {
      console.error(`Error al buscar la factura (${buttonClick.target.id}).`, error);
    }
  }


  async getCompanyByUserAuthenticatedAsync() {
    try {
      const response: any = await firstValueFrom(
        this.userAuthenticatedService.companyObservable.pipe(
          filter((company: any) => !!company && company.companyId !== 0)
        )
      );
      this.companyId = response.companyId;
    } catch (error) {
      console.error('Error al obtener la empresa del usuario autenticado.', error);
    }
  }

  async getTransportInvoiceById() {
    try {
      const response: TransportInvoiceModel = await firstValueFrom(this.transportInvoiceService.getTransportInvoiceById(this.transportInvoiceId));
      this.transportInvoiceContract = response;
      this.validateForm(response);
    } catch (error) {
      console.error('Error al obtener la factura de transporte por Id.', error);
    }
  }

  async getTransportInvoiceByKeys() {
    const providerId = this.formTransportInvoice.get('providerId')?.value;
    const documentNumber = this.formTransportInvoice.get('documentNumber')?.value;
    if (!providerId || !documentNumber) return;
    try {
      const response: TransportInvoiceModel = await firstValueFrom(
        this.transportInvoiceService.getTransportInvoiceByKeys(providerId, documentNumber)
      );
      if (response && response.transportInvoiceId !== 0) {
        this.transportInvoiceId = response.transportInvoiceId;
        this.transportInvoiceContract = response;
        this.validateForm(response);
        this.location.replaceState(`/${this.url}/register/${this.transportInvoiceId}`);
      }
    } catch (error) {
      console.error('Error al consultar la factura de transporte por llaves.', error);
    }
  }

  onProviderChange(providerId: number) {
    this.quantityDetails = 0;
    this.transportInvoiceId = 0;
    this.transportInvoiceContract = new TransportInvoiceModel();
    this.transportInvoiceContract.companyId = this.companyId;
    this.transportInvoiceContract.providerId = providerId;
    this.validateForm(this.transportInvoiceContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getCompanyByUserAuthenticatedAsync(),
      this.getPermissionProfileByUrl(),
      this.getAllLists(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.transportInvoiceId !== null && this.transportInvoiceId !== 0) {
      await this.getTransportInvoiceById();
    } else {
      this.createNewRegister();
    }
  }

  async send() {
    this.validateFormControls();
    if (this.formTransportInvoice.valid) {
      const model = this.formTransportInvoice.getRawValue() as TransportInvoiceModel;
      model.companyId = this.companyId || model.companyId;
      if (this.transportInvoiceId === 0) {
        try {
          const response: TransportInvoiceModel = await firstValueFrom(this.transportInvoiceService.createTransportInvoice(model));
          this.transportInvoiceId = response.transportInvoiceId;
          this.transportInvoiceContract = response;
          this.validateForm(this.transportInvoiceContract);
          this.location.replaceState(`/${this.url}/register/${this.transportInvoiceId}`);
          this.toastHandlerService.showToast(
            'success',
            'La factura de transporte fue creada exitosamente.'
          );
        } catch (error) {
          console.error('Error al crear la factura de transporte.', error);
        }
      } else {
        this.transportInvoiceContract.providerId = model.providerId;
        this.transportInvoiceContract.documentNumber = model.documentNumber;
        this.transportInvoiceContract.dateTransportInvoice = model.dateTransportInvoice;
        this.transportInvoiceContract.otherValues = model.otherValues;
        this.transportInvoiceContract.observation = model.observation;
        this.transportInvoiceContract.active = model.active;
        try {
          const response: TransportInvoiceModel = await firstValueFrom(this.transportInvoiceService.updateTransportInvoice(this.transportInvoiceContract));
          this.transportInvoiceContract = response;
          this.validateForm(this.transportInvoiceContract);
          this.toastHandlerService.showToast(
            'success',
            'La factura de transporte fue modificada exitosamente.'
          );
        } catch (error) {
          console.error('Error al modificar la factura de transporte.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      providerId: {
        required: 'El campo Proveedor es obligatorio.',
        min: 'Debe seleccionar un Proveedor válido.'
      },
      documentNumber: {
        required: 'El campo Número Documento es obligatorio.',
        maxlength: 'El Número Documento no puede tener más de 15 caracteres.'
      },
      dateRemission: {
        required: 'El campo Fecha Remisión es obligatorio.'
      },
      otherValues: {
        required: 'El campo Valor Otros es obligatorio.',
        min: 'El valor no puede ser menor a 0.',
        max: 'El valor no puede superar 99,999,999,999.99.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formTransportInvoice.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState() {
    if (this.transportInvoiceContract.active) {
      this.disabledForm = false;
      this.titleState = 'Cerrar';
      this.severityState = 'danger';
      this.stateTransportInvoice = 'Abierto';
      setTimeout(() => this.formTransportInvoice.enable());
    } else {
      this.disabledForm = true;
      this.titleState = 'Abrir';
      this.severityState = 'success';
      this.stateTransportInvoice = 'Cerrado';
      setTimeout(() => {
        this.formTransportInvoice.disable(),
          this.formControlStateService.setControlState(this.formTransportInvoice, ['providerId', 'documentNumber'], true)
      });

    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formTransportInvoice.disable());
    }
  }

  validateForm(transportInvoice: TransportInvoiceModel) {
    this.formTransportInvoice = this.formBuilder.group({
      providerId: [transportInvoice.providerId, [Validators.required, Validators.min(1)]],
      documentNumber: [transportInvoice.documentNumber, [Validators.required, Validators.maxLength(15)]],
      dateTransportInvoice: [transportInvoice.dateTransportInvoice ? this.dateConverterService.convertDatePreserveDay(transportInvoice.dateTransportInvoice) : null, [Validators.required]],
      otherValues: [transportInvoice.otherValues, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      observation: [transportInvoice.observation, [Validators.maxLength(250)]],
      active: [transportInvoice.active]
    });

    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formTransportInvoice.controls).forEach((key) => {
      const control = this.formTransportInvoice.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
